<template>
  <div style="padding: 20px;background-color: #ffffff;">
    <div class="">
      <div @keyup.enter.stop="getPage({pageNum: 1})">
        <el-select v-model="queryParam.batchId" placeholder="选择考试" @change="getPage({pageNum: 1})" filterable style="width: 200px;margin-right:10px;">
          <el-option v-for="(item,index) in batchList" :key="index" :label="item.batchName" :value="item.batchId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-button @click="getPage({pageNum: 1})" type="primary">搜索</el-button>
      </div>
      <div class="text-right" style="margin-top: 10px;">
      </div>
    </div>
    <div ref="page" style="margin-top: 12px;">
      <el-table :data="page.list" stripe :height="tableHeight" size="medium">
        <el-table-column prop="categoryName" label="分类名称"></el-table-column>
        <el-table-column prop="specialtyName" label="专业名称"></el-table-column>
        <el-table-column prop="gradeInfoList2" label="已发布级别">
          <template slot-scope="scope">
            {{Tool.joinList(scope.row.gradeInfoList2,'gradeName','/')}}
          </template>
        </el-table-column>
        <el-table-column prop="gradeInfoList1" label="未发布级别">
          <template slot-scope="scope">
            {{Tool.joinList(scope.row.gradeInfoList1,'gradeName','/')}}
          </template>
        </el-table-column>
        <el-table-column prop="specialtyImageUrl" label="专业图标">
          <template slot-scope="scope">
            <div>
              <el-image v-if="scope.row.specialtyImageUrl2" :src="scope.row.specialtyImageUrl2" :preview-src-list="[scope.row.specialtyImageUrl2]" style="width: 50px;height: 50px;"></el-image>
            </div>
            <el-upload class="inline-block" action="" :http-request="uploadOSS1" :data="scope.row" :show-file-list="false" accept=".png,.jpg,.gif">
              <el-button type="text" style="color: #1890FF;margin-left: 0px;">上传文件</el-button>
            </el-upload>
          </template>
        </el-table-column>
        <el-table-column prop="directionImageUrl" label="考试指南">
          <template slot-scope="scope">
            <div>
              <el-image v-if="scope.row.directionImageUrl2" :src="scope.row.directionImageUrl2" :preview-src-list="[scope.row.directionImageUrl2]" style="width: 50px;height: 50px;"></el-image>
            </div>
            <el-upload class="inline-block" action="" :http-request="uploadOSS2" :data="scope.row" :show-file-list="false" accept=".png,.jpg,.gif">
              <el-button type="text" style="color: #1890FF;margin-left: 0px;">上传文件</el-button>
            </el-upload>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="toGrade(scope.row)">专业级别管理</el-button>
            <el-button size="mini" type="text" @click="publishAttr(scope.row)">设置考级须知</el-button>
            <el-button size="mini" type="text" @click="editRead(scope.row)">设置摆件指引</el-button>
            <template v-if="scope.row.gradeInfoList0.length==0 && scope.row.specialtyImageUrl && scope.row.directionImageUrl">
              <el-button v-if="scope.row.status==2" size="mini" type="text" @click="publish(scope.row)">修改时间</el-button>
              <el-button v-if="scope.row.status==1 && editForm.show == false && scope.row.examineeNotice!= null" size="mini"
                         type="text"
                         @click="publish(scope.row)">发布
              </el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px;">
        <el-pagination class="text-center" background
                       :page-sizes="[20, 50, 100, 200]" layout="total, sizes, prev, pager, next, jumper"
                       :total="page.total" :page-size="page.pageSize" :current-page="page.pageNum"
                       @current-change="getPage({pageNum:$event})" @size-change="getPage({pageNum:1,pageSize:$event})"></el-pagination>
      </div>
    </div>
    <el-dialog :title="(editForm.dataId?'设置':'设置')+editForm.title" v-if="editForm.show" :visible.sync="editForm.show" width="600px"
               :close-on-press-escape="false" :close-on-click-modal="false" :destroy-on-close="true">
      <Edit :dataId="editForm.dataId" @close="getPage()"></Edit>
    </el-dialog>
    <el-dialog :title="(bookForm.dataId?'编辑':'编辑')+bookForm.title" v-if="bookForm.show" :visible.sync="bookForm.show" width="500px"
               :close-on-press-escape="false" :close-on-click-modal="false" :destroy-on-close="true">
      <BookEdit :row="bookForm.row" @close="getPage()"></BookEdit>
    </el-dialog>
    <el-dialog title="设置摆件指引" v-if="readForm.show" :visible.sync="readForm.show" width="550px"
               :close-on-press-escape="false" :close-on-click-modal="false" :destroy-on-close="true">
      <Read :row="readForm.row" @close="getPage()"></Read>
    </el-dialog>
    <el-dialog :title="(attrForm.dataId?'设置':'设置')+attrForm.title" v-if="attrForm.show" :visible.sync="attrForm.show" width="600px"
               :close-on-press-escape="false" :close-on-click-modal="false" :destroy-on-close="true">
      <EditAttr :row="attrForm.row" @close="getPage()"></EditAttr>
    </el-dialog>
  </div>
</template>
<script>
import Edit from './specialty-edit'
import BookEdit from './specialty-book-edit'
import Read from './specialty-read-edit'
import EditAttr from './specialty-attrbute-edit'

export default {
  name: 'list',
  components: { Edit, BookEdit, Read, EditAttr },
  props: [],
  data () {
    return {
      tableHeight: 200,
      queryParam: { batchId: this.$route.query.batchId },
      page: { pageSize: 20, pageNum: 1 },
      editForm: { show: false, dataId: '', title: '时间' },
      bookForm: { show: false, row: null, title: '教材' },
      attrForm: { show: false, row: null, title: '考级须知' },
      readForm: { show: false, row: null },
      batchList: []
    }
  },
  async created () {
    this.batchList = await this.$HTTP.ApiBatch.getList()
    if (this.Tool.isNull(this.batchList)) {
      throw new Error('请先添加考试数据')
    }
    if (!this.queryParam.batchId) {
      this.queryParam.batchId = this.batchList[0].batchId
    }
    await this.getPage()
  },
  async mounted () {
    this.Tool.windowResizeEvent(() => {
      this.tableHeight = this.Tool.calcTableHeight(this.$refs['page'])
    })
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async uploadOSS1 (event) {
      try {
        if (event.file.size > 1024 * 1024 * 2) {
          throw new Error('仅支持JPG、PNG、GIF格式图片文件，且文件大小小于2MB')
        }
        let url = await this.$HTTP.ApiOss.uploadOSS(event.file, `logo`, '.png,.jpg,.gif', 'public-read')
        await this.$HTTP.ApiSpecialty.edit({ specialtyId: event.data.specialtyId, specialtyImageUrl: url })
        await this.getPage()
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async uploadOSS2 (event) {
      try {
        if (event.file.size > 1024 * 1024 * 2) {
          throw new Error('仅支持JPG、PNG、GIF格式图片文件，且文件大小小于2MB')
        }
        let url = await this.$HTTP.ApiOss.uploadOSS(event.file, `direction`, '.png,.jpg,.gif', 'public-read')
        await this.$HTTP.ApiSpecialty.edit({ specialtyId: event.data.specialtyId, directionImageUrl: url })
        await this.getPage()
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async getPage (queryParam) {
      try {
        this.editForm.show = false
        this.editForm.dataId = null
        this.bookForm.show = false
        this.bookForm.row = null
        this.readForm.show = false
        this.readForm.row = null
        this.attrForm.show = false
        this.attrForm.row = null
        this.queryParam = Object.assign({}, this.queryParam, queryParam)
        let page = await this.$HTTP.ApiSpecialty.getPage(this.queryParam)
        for (let i in page.list) {
          let item = page.list[i]
          item.gradeInfoList0 = []
          item.gradeInfoList1 = []
          item.gradeInfoList2 = []
          if (!this.Tool.isNull(item.gradeInfoList)) {
            for (let j in item.gradeInfoList) {
              let grade = item.gradeInfoList[j]
              if (Number(grade.status) === 0) {
                item.gradeInfoList0.push(grade)
                item.gradeInfoList1.push(grade)
              } else if (Number(grade.status) === 1) {
                item.gradeInfoList1.push(grade)
              } else if (Number(grade.status) === 2) {
                item.gradeInfoList2.push(grade)
              }
            }
          }
          if (item.specialtyImageUrl) {
            item.specialtyImageUrl2 = await this.$HTTP.ApiOss.signatureUrl(item.specialtyImageUrl, 'public-read')
          }
          if (item.directionImageUrl) {
            item.directionImageUrl2 = await this.$HTTP.ApiOss.signatureUrl(item.directionImageUrl, 'public-read')
          }
        }
        this.page = page
        this.$nextTick(() => {
          let wrapper = window.document.getElementsByClassName('el-table__body-wrapper')
          if (wrapper) {
            wrapper[0].scrollTop = 0
          }
        })
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async publish (row) {
      this.editForm.show = true
      if (row) {
        this.editForm.dataId = row.specialtyId
      } else {
        this.editForm.dataId = ''
      }
    },
    async editBook (row) {
      this.bookForm.show = true
      if (row) {
        this.bookForm.row = row
      } else {
        this.bookForm.row = null
      }
    },
    async editRead (row) {
      this.readForm.show = true
      if (row) {
        this.readForm.row = row
      } else {
        this.readForm.row = null
      }
    },
    async publishAttr (row) {
      this.attrForm.show = true
      if (row) {
        this.attrForm.row = row
      } else {
        this.attrForm.row = null
      }
    },
    async toGrade (row) {
      this.$router.push(`./grade?batchId=${row.batchId}&specialtyId=${row.specialtyId}`)
    },
    async unPublish (row) {
      try {
        let confirm = await this.$confirm('确定要取消发布该记录吗？', '提示', { type: 'warning' })
        if (confirm === 'confirm') {
          await this.$HTTP.ApiSpecialty.unPublish(row.specialtyId)
          await this.getPage()
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    }
  }
}
</script>
